import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsSurfingNormalLarge = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M35.4 1.064c-3.163.555-11.317 3.344-18.709 17.246-7.22 13.572-8.575 22.181-8.629 22.541l-.173 1.15h6.543l3.66 5.424.855-.786c.268-.246 6.648-6.183 13.865-19.756 7.391-13.9 5.145-22.22 3.8-25.232l-.4-.758-.812.171zM14.363 40h-4.1c.607-2.753 2.618-10.28 8.186-20.75C24.163 8.51 30.311 4.846 33.715 3.6zm16.683-14.056c-5.555 10.447-10.682 16.341-12.627 18.39l-2.29-3.4L35.484 4.532c.87 3.516 1.276 10.668-4.438 21.412z"
        fill=""
      />
    </svg>
  )
);
SvgSportsSurfingNormalLarge.defaultProps = {
  color: 'currentColor',
  size: 48,
  title: undefined,
  titleId: undefined
};
SvgSportsSurfingNormalLarge.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsSurfingNormalLarge;
